import React, { useState, useMemo } from "react";
import { SitebarCollapsable } from "components/SitebarCollapsable";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useEffectOnce } from "hooks";
import { Select } from "components/Utils";
import { fetchWrapper } from "data/FetchWrapper";

const getCountries = (item, countries = []) => {
  if (item.country) {
    countries.push(item.country);
  }
  if (item.children) {
    for (let child of item.children) {
      getCountries(child, countries);
    }
  }
  return countries;
};

const renderNav = (items = [], level = 0) =>
  items.length > 0 ? (
    <Nav vertical>
      {items.map((item, i) => (
        <NavItem key={`${item.label}-${level}-${i}`}>
          {item.children != null ? (
            <>
              <h4>{item.label}</h4>
              {renderNav(item.children, level + 1)}
            </>
          ) : (
            <NavLink target="_blank" href={item.href}>
              {item.label}
            </NavLink>
          )}
        </NavItem>
      ))}
    </Nav>
  ) : null;

const filterLinks = (_item, node, value) => {
  var item = { ..._item };
  if (item.children) {
    item.children = item.children
      .map((item) => filterLinks(item, node, value))
      .filter((item) => item !== null);
  }
  return item[node] == null || item[node] === value ? item : null;
};

const RelevantSites = () => {
  const [items, setItems] = useState([]);
  const [country, setCountry] = useState(null);
  useEffectOnce(() => {
    fetchWrapper
      .get("/api/file/web-ressources")
      .then((items) => setItems(items));
  });
  const countries = useMemo(() => {
    const countries = [];
    for (let item of items) {
      getCountries(item, countries);
    }
    countries.sort();
    return [...new Set(countries)];
  }, [items]);
  const filteredItem = useMemo(
    () =>
      items
        .map((item) => filterLinks(item, "country", country))
        .filter(
          (item) => item != null && (!item.children || item.children.length > 0)
        ),
    [country, items]
  );
  return (
    <SitebarCollapsable
      header="Other web ressources"
      empty="Currently no other web ressources available!"
    >
      <Select
        value={country}
        setValue={setCountry}
        allowSetEmpty={true}
        items={countries}
      />
      {renderNav(filteredItem)}
    </SitebarCollapsable>
  );
};

export { RelevantSites };
